export const getDelayInMs = (timeStr) => {
    if (!timeStr) return 0;
  
    const match = timeStr.match(/^(\d+)(s|m)$/);
    if (!match) return 0;
  
    const value = parseInt(match[1], 10);
    const unit = match[2];
  
    if (unit === "s") return value * 1000;
    if (unit === "m") return value * 60 * 1000;
  
    return 0;
  };
  